import black_card from 'assets/images/product_picker_page/chime_card_black.webp';
import green_card from 'assets/images/product_picker_page/chime_card_green.webp';
import metal_card from 'assets/images/product_picker_page/chime_card_metal.webp';

import { BlackFilledCircleSvg } from './components/BlackFilledCircleSvg';
import { GreenFilledCircleSvg } from './components/GreenFilledCircleSvg';
import { MetalFilledCircle } from './components/MetalFilledCircle';

const CHIME_CARD_GREEN = {
  id: 'chime_card_green_plastic',
  name: 'Evergreen',
  description: '',
  image: green_card,
  price: null,
  radio: <GreenFilledCircleSvg />,
};

const CHIME_CARD_BLACK = {
  id: 'chime_card_black_plastic',
  name: 'Black',
  description: '',
  image: black_card,
  price: null,
  radio: <BlackFilledCircleSvg />,
};

export const CHIME_CARD_METAL = {
  id: 'chime_card_silver_metal',
  name: 'Titanium',
  description: '$50 + tax',
  image: metal_card,
  price: 50,
  radio: <MetalFilledCircle />,
};

export const CHIME_CARDS = [CHIME_CARD_BLACK, CHIME_CARD_GREEN];

// All available cards
export const CHIME_CARDS_WITH_METAL = [...CHIME_CARDS, CHIME_CARD_METAL];
